;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["initial-id-type", "initial-id-number", "initial-first-name", "initial-validated", "id-lookup-path"],
  data: function data() {
    return {
      isVerificationRequired: null,
      enableVerify: false,
      isCitizen: false,
      isResident: false,
      isForeigner: false,
      idType: this.initialIdType,
      idNumber: this.initialIdNumber,
      validationFirstName: this.initialFirstName,
      isValidating: false,
      validated: this.initialValidated,
      firstName: this.validationFirstName,
      lastName: null,
      otherName: null,
      dob: null,
      gender: null,
      nationality: null,
      error: null,
      country_of_nationality: null,
      email: null,
      primary_phone: null,
      secondary_phone: null,
      address_line_one: null,
      address_line_two: null,
      city: null,
      state: null,
      country_of_residence: null,
      password: null,
      checkedData: true
    };
  },
  methods: {
    changeType: function changeType(type) {
      this.invalidate();

      if (type == 1) {
        this.idType = "citizen";
        this.isCitizen = true;
        this.isResident = false;
        this.isForeigner = false;
      }
      if (type == 2) {
        this.isCitizen = false;
        this.isResident = true;
        this.isForeigner = false;
      }
      if (type == 3) {
        this.isCitizen = false;
        this.isResident = false;
        this.isForeigner = true;
      }
    },
    validateIdNumber: function validateIdNumber(evt) {
      this.isValidating = true;
      this.error = null;

      if (!this.isVerificationRequired) {
        return;
      }
      if (this.idNumber == null || this.idNumber == "" || this.validationFirstName == null || this.validationFirstName == "") {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "We are missing either your ID Number or First Name. Please check !"
        });

        return;
      }

      $.ajax(this.idLookupPath, {
        data: {
          id_type: this.idType,
          id_number: this.idNumber,
          first_name: this.validationFirstName
        },
        success: function (response) {
          if (response.status === "ok") {
            this.validated = true;
            this.idNumber = response.data.id_number;
            this.firstName = response.data.first_name;
            this.lastName = response.data.surname;
            this.otherName = response.data.surname;
            this.dob = response.data.dob;
            this.gender = response.data.gender;
            this.nationality = response.data.citizenship;
          } else {
            this.error = response.message;
          }
        }.bind(this),
        error: function () {}.bind(this),
        complete: function () {
          this.isValidating = false;
        }.bind(this)
      });
    },
    invalidate: function invalidate() {
      this.validated = false;
      this.firstName = null;
      this.lastName = null;
      this.id_number = null;
      this.first_name = null;
      this.last_name = null;
      this.gender = null;
      this.nationality = null;
      this.otherName = null;
      this.country_of_nationality = null;
      this.email = null;
      this.primary_phone = null;
      this.secondary_phone = null;
      this.address_line_one = null;
      this.address_line_two = null;
      this.city = null;
      this.state = null;
      this.country_of_residence = null;
      this.password = null;
    }
  },
  mounted: function mounted() {
    this.isVerificationRequired = this.$attrs["is-verification-required"];
    if (this.isVerificationRequired === "true") {
      this.enableVerify = true;
    }
    this.isCitizen = true;
    this.changeType(1);

    if (this.validationFirstName && this.idNumber && this.idType) this.validateIdNumber();
  },

  computed: {},
  validated: {
    validated: function validated() {
      $("#user_role_ids").select2();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-157b2155", __vue__options__)
  } else {
    hotAPI.reload("data-v-157b2155", __vue__options__)
  }
})()}